// PN-11 (T-430) — UN SEUL indicateur de complétude : celui de l'agent (`completude_agent`, calculé par le serveur : `_calculate_completude`).
// Les compteurs « X/Y » de chaque onglet en DÉRIVENT (somme des sections de l'agent rattachées à l'onglet) : plus de second calcul côté écran,
// et la somme des onglets redonne exactement le pourcentage de l'en-tête.
// Chaque section de l'agent a un onglet (un test serveur le vérifie) ; l'onglet DAL n'a pas de section de l'agent : pas de compteur.
export const SECTIONS_PAR_ONGLET = {
  infos: ["Identite", "Adresse"],
  operation: ["Contrats", "Visite", "Installateur", "Devis"],
  conformite: ["Financement", "ANAH", "Dates"],
  finance: ["Paiement"],
};

/** { onglet: { filled, total, missing[] } } — vide si l'agent n'a pas détaillé ses sections (saisie manuelle, ancien serveur). */
export function completudeParOnglet(agent) {
  if (!agent || agent.source === "manual" || !agent.sections) return {};
  const out = {};
  for (const [onglet, noms] of Object.entries(SECTIONS_PAR_ONGLET)) {
    const parts = noms.map((n) => agent.sections[n]).filter(Boolean);
    if (!parts.length) continue;
    out[onglet] = {
      filled: parts.reduce((n, s) => n + (s.filled || 0), 0),
      total: parts.reduce((n, s) => n + (s.total || 0), 0),
      missing: parts.flatMap((s) => s.manquants || []),
    };
  }
  return out;
}
